var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 82,
    viewBox: "0 0 90 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3793 0.624756H0.393555C5.98123 1.86646 9.91328 6.83328 9.91328 12.421V81.9565C17.5705 74.2993 21.7095 64.1587 21.7095 53.3972V14.4905C21.7095 13.4557 22.5373 12.421 23.779 12.421C24.8137 12.421 25.8485 13.2488 25.8485 14.4905V66.2282C33.5057 58.571 37.6447 48.4304 37.6447 37.669V14.4905C37.6447 13.4557 38.4725 12.421 39.7142 12.421C40.749 12.421 41.7837 13.2488 41.7837 14.4905V50.4999L52.1313 40.1524C52.5452 39.7385 52.7521 39.3246 52.9591 38.9107V38.7037C53.373 38.0829 53.373 37.462 53.5799 36.6342C54.6147 23.1824 65.79 12.421 79.6557 12.421H89.3824L77.3793 0.624756Z",
    fill: "#2029DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo7);
export default __webpack_public_path__ + "static/media/logo7.9a6d0ca87465b8eeff563b49384be942.svg";
export { ForwardRef as ReactComponent };